<template>
  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Exibir</label>
            <v-select
              v-model="perPage"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entradas</label>
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <label for="institution-id">Instituição</label>
            <v-select
              id="institution-id"
              v-model="institutionFilter"
              name="institution-id"
              :options="institutionOptions"
              label="label"
              item-value="value"
              item-text="label"
              :reduce="option => option.value"
              @input="fetchWorkplaces"
            >
              <span slot="no-options">Nenhuma instituição encontrada.</span>
            </v-select>
          </b-col>
          <b-col
            cols="12"
            md="4"
          >
            <div class="d-flex w-100">
              <div class="flex-grow-1">
                <label for="workplace-id">Unidade</label>
                <v-select
                  id="workplace-id"
                  v-model="workplaceFilter"
                  name="workplace-id"
                  :options="workplaceOptions"
                  label="label"
                  item-value="value"
                  item-text="label"
                  :reduce="option => option.value"
                  :disabled="!institutionFilter"
                >
                  <span slot="no-options">Nenhuma unidade encontrada.</span>
                </v-select>
              </div>
              <div class="pt-2-5 ml-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="btn-icon mr-1"
                  @click="refetchData"
                >
                  Buscar
                  <feather-icon
                    icon="SearchIcon"
                    size="16"
                  />
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refInstitutionListTable"
        class="position-relative"
        :items="fetchItems"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro correspondente encontrado"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ resolvePhysicianStatusLabel(data.item.status) }}
          </b-badge>
        </template>
        <template #cell(physician.name)="data">
          <strong>{{ data.item.physician.name }}</strong>
          <div>{{ formatCpf(data.item.physician.cpf) }}</div>
        </template>
        <template #cell(physician_company.name)="data">
          <strong>{{ data.item.physician_company.name }}</strong>
          <div>{{ formatCnpj(data.item.physician_company.cnpj) }}</div>
        </template>
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              v-if="['pending', 'denied'].includes(data.item.status)"
              @click="approveCnpj(data.item, 'approved')"
            >
              <feather-icon icon="CheckCircleIcon" />
              <span class="align-middle ml-50">Aprovar</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="['pending', 'approved'].includes(data.item.status)"
              @click="approveCnpj(data.item, 'denied')"
            >
              <feather-icon icon="XCircleIcon" />
              <span class="align-middle ml-50">Recusar</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Exibindo {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalInstitutions"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-modal
      id="modal-workplace-physician-cnpj-motive-modal"
      ref="workplacePhysicianCnpjMotiveModal"
      :title="workplacePhysicianCnpj ? `${getStatusLabelModal(workplacePhysicianCnpj.company_status)} ${workplacePhysicianCnpj.company_name}` : ''"
      hide-footer
      size="md"
      centered
    >
      <div>
        <div>
          <div v-if="workplacePhysicianCnpj.company_status == 'approved'">
            Deseja realmente autorizar essa empresa?
          </div>
          <b-form-group
            v-if="workplacePhysicianCnpj.company_status != 'approved'"
            class="mt-1"
            label="Motivo"
            label-for="motive"
          >
            <b-form-textarea
              id="motive"
              v-model="workplacePhysicianCnpj.motive"
              name="motive"
              placeholder="Descreva o motivo..."
              rows="3"
            />
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button
            variant="primary"
            @click="approveMotiveCnpj(workplacePhysicianCnpj.company_status)"
          >
            {{ getStatusLabelModal(workplacePhysicianCnpj.company_status) }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BTable, BPagination, BBadge, BButton, BDropdownItem, BDropdown, BFormTextarea, BModal, BFormGroup,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import { onUnmounted, ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { formatCnpj, formatCpf, maskCnpj } from '@core/utils/utils'
import useWorkplacePhysicianCompanyList from './useWorkplacePhysicianCompanyList'
import reportStoreModule from '../reportStoreModule'

export default {
  components: {
    BFormGroup,
    BModal,
    BFormTextarea,
    BDropdown,
    BDropdownItem,
    BButton,
    BBadge,
    BCard,
    BRow,
    BCol,
    BTable,
    BPagination,
    vSelect,
  },
  directives: {
    Ripple,
  },
  methods: { formatCnpj, formatCpf },
  setup() {
    const STORE_MODULE_NAME = 'app-reports'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, reportStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const workplacePhysicianCnpjModal = ref(null)
    const workplacePhysicianCnpjMotiveModal = ref(null)
    const workplacePhysicianCnpjContractModal = ref(null)
    const institutionOptions = ref([])
    const workplaceOptions = ref([])
    const statusOptions = [
      { label: 'Pendente', value: 'pending' },
      { label: 'Ativo', value: 'active' },
      { label: 'Inativo', value: 'inactive' },
    ]
    const workplacePhysicianCnpj = ref({
      contract_files: [],
      company_name: null,
      company_status: null,
      workplace_name: null,
      workplace_id: null,
      workplace_physician_company_id: null,
      motive: null,
      status: null,
      dueDate: null,
    })

    const {
      fetchItems,
      tableColumns,
      perPage,
      currentPage,
      totalInstitutions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInstitutionListTable,
      refetchData,
      resolvePhysicianStatusLabel,
      resolveStatusVariant,
      statusFilter,
      institutionFilter,
      workplaceFilter,
      getStatusLabelModal,
    } = useWorkplacePhysicianCompanyList()

    store.dispatch('app-reports/fetchInstitutions', { perPage: 99999999 })
      .then(response => {
        institutionOptions.value = response.data.data.map(inst => ({
          value: inst.id,
          label: `${inst.name} | ${maskCnpj(inst.cnpj)}`,
        }))
      })

    const fetchWorkplaces = () => {
      if (institutionFilter.value) {
        store.dispatch('app-reports/fetchWorkplaceByInstitution', { institution_id: institutionFilter.value })
          .then(response => {
            workplaceOptions.value = response.data.data.map(w => ({
              value: w.id,
              label: w.name,
            }))
          })
      } else {
        workplaceOptions.value = []
        workplaceFilter.value = null
      }
    }

    function approveCnpj(company, status) {
      workplacePhysicianCnpj.value.workplace_physician_company_id = company.id
      workplacePhysicianCnpj.value.company_name = company.physician_company.name
      workplacePhysicianCnpj.value.company_status = status // ssssssss
      workplacePhysicianCnpj.value.motive = null
      workplacePhysicianCnpjMotiveModal.value.show()
    }

    function approveMotiveCnpj() {
      const data = {
        id: workplacePhysicianCnpj.value.workplace_physician_company_id,
        motive: workplacePhysicianCnpj.value.motive,
        status: workplacePhysicianCnpj.value.company_status,
      }
      store.dispatch('app-reports/updatePhysicianCompany', data)
        .then(() => {
          refetchData()
          workplacePhysicianCnpjMotiveModal.value.hide()
        }).catch(() => {
        //
        })
    }

    return {
      approveMotiveCnpj,
      approveCnpj,
      fetchWorkplaces,
      institutionOptions,
      workplaceOptions,
      resolvePhysicianStatusLabel,
      resolveStatusVariant,
      fetchItems,
      tableColumns,
      perPage,
      currentPage,
      totalInstitutions,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInstitutionListTable,
      refetchData,
      avatarText,
      statusOptions,
      statusFilter,
      institutionFilter,
      workplaceFilter,
      workplacePhysicianCnpjModal,
      workplacePhysicianCnpjMotiveModal,
      workplacePhysicianCnpjContractModal,
      workplacePhysicianCnpj,
      getStatusLabelModal,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
